import React from "react";
import { Routes, Route, BrowserRouter as Router } from "react-router-dom";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import AboutPage from "./components/pages/AboutPage";
import ContactsPage from "./components/pages/ContactsPage";
import NewInPage from "./components/pages/NewInPage";

function Shop() {
	return;
}

const Routing = () => {
	return (
		<Router>
			<Routes>
				<Route exact path="/" element={<App />} />
				<Route path="/new-in" element={<NewInPage />} />
				<Route path="/shop" element={Shop} />
				<Route path="/about" element={<AboutPage />} />
				<Route path="/contacts" element={<ContactsPage />} />
				<Route path="*" element={<App />} />
			</Routes>
		</Router>
	);
};

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);
root.render(
	<React.StrictMode>
		<Routing />
	</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
